// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get, startCase, toLower} from 'lodash';

// Components
import Checkbox from '../core/checkbox';
import DateRange from '../core/date-range';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import Select from '../core/select';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './violations.scss';

const servicesDataKey = 'violations';

class Violations extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'mediaItemTitle',
                link: '/investigation/violations',
                linkKey: 'violationId',
                title: 'Media Item Title',
                type: 'link',
                width: '22%',
            },
            {
                dataKey: 'category',
                title: 'Category',
                width: '10%',
            },
            {
                dataKey: 'statusCode',
                renderRowCallback: this.renderStatusCode,
                title: 'Status',
                width: '10%',
            },
            {
                dataKey: 'rule',
                title: 'Rule',
                width: '27%',
            },
            {
                dataKey: 'dateCreated',
                title: 'Date Created',
                type: 'date',
                width: '8%',
            },
            {
                dataKey: 'network',
                title: 'Network Name',
                width: '8%',
            },
            {
                dataKey: 'lastModifiedBy',
                title: 'Last Modified By',
                width: '15%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getRowDetails() {
        return {
            whitelistKeys: [
                'violationId',
                'correlationId',
                'category',
                'statusCode',
                'rule',
                'reason',
                'dateCreated',
                'lastUpdated',
                'lastModifiedBy',
                'idFromPartner',
                'provider',
                'network',
            ],
        };
    }

    getTablewithsortProps() {
        return {
            activeRowValueKey: 'routerParams.ruleId',
            columnConfig: this.getColumnConfig(),
            notSortable: ['mediaItemTitle'],
            formName: servicesDataKey,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            updateOnUrlChange: false,
            ...this.props,
        };
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Correlation ID" name="correlationId" title="Use wildcard (*) for partial match" />
            <Select label="Category" name="category">
                <option value="">Filter by Category</option>
                <option value="IVI">IVI</option>
                <option value="EST">EST</option>
                <option value="ENRICH">Enrich</option>
                <option value="PRE_PROD">Pre Prod</option>
                <option value="AUTO_MAP">Auto Map</option>
                <option value="VALIDATION">Validation</option>
            </Select>
            <Select label="Status Code" name="statusCode">
                <option value="">Filter by Status Code</option>
                <option value="WARNING">Warning</option>
                <option value="ERROR">Error</option>
            </Select>
            <DateRange label="Created" name="dateCreated" />
            <DateRange label="Last Updated" name="lastUpdated" />
            <Input label="Rule" name="rule" title="Use wildcard (*) for partial match" />
            <Input label="Reason" name="reason" title="Use wildcard (*) for partial match" />
            <Checkbox label="Active Only" name="unexpiredOnly" value="true" />
            <FormButtons />
        </ServicesSearchForm>
    );

    renderStatusCode = (dataRow, {dataKey}) => startCase(toLower(get(dataRow, dataKey)));

    render() {
        const {searchData} = this.props;

        return (
            <div className="violations">
                <ServicesExportPanelAction searchData={searchData} />
                <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                <SearchPagination {...this.getPaginationProps()} />
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
        );
    }
}

Violations.propTypes = {
    query: PropTypes.object,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(Violations, servicesDataKey);
